import React, { useContext } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from "../../routes/AuthContext";
import "./BottomNav.css";

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { isLoggedIn, isAuthenticated } = useContext(AuthContext);
  const loggedIn = isLoggedIn || isAuthenticated;

  // Account/Login active check
  const isAccountActive =
    location.pathname === "/account" || location.pathname === "/login";

  return (
    <nav className="bottom-nav">
      <NavLink
        to="/"
        className={({ isActive }) =>
          `bottom-nav-item ${isActive ? "active" : ""}`
        }
      >
        <i className="bi bi-shop"></i>
        <span>Home</span>
      </NavLink>

      <NavLink
        to="/wishlist"
        className={({ isActive }) =>
          `bottom-nav-item ${isActive ? "active" : ""}`
        }
      >
        <i className="bi bi-heart"></i>
        <span>Wishlist</span>
      </NavLink>

      <NavLink
        to="/cart"
        className={({ isActive }) =>
          `bottom-nav-item ${isActive ? "active" : ""}`
        }
      >
        <i className="bi bi-cart"></i>
        <span>Cart</span>
      </NavLink>

      

      <div
        className={`bottom-nav-item ${isAccountActive ? "active" : ""}`}
        onClick={() => navigate(loggedIn ? "/account" : "/login")}
      >
        <i className="bi bi-person"></i>
        <span>{loggedIn ? "Account" : "Login"}</span>
      </div>
    </nav>
  );
};

export default BottomNav;
